import { cloneElement } from "react";
import { SvgIconProps, useTheme } from "@mui/material";
import { IconTypes } from "./types";
import { icon2iconUrl } from "./constant";

export type CustomIconProps = {
  icon: IconTypes;
  rotated?: boolean;
};

export const MediumCustomIcon = (props: CustomIconProps & SvgIconProps) => {
  const theme = useTheme();
  const { rotated, style, ...rest } = props;
  const Res = icon2iconUrl[props.icon];
  const stroke = props.stroke ? props.stroke : theme.palette.primary.dark;

  if (Res) {
    return cloneElement(Res, {
      width: 16,
      height: 16,
      ...rest,
      stroke,
      style: {
        ...style,
        transform: rotated ? "rotate(180deg)" : "rotate(0deg)",
        transition: "transform 0.2s ease-in-out",
      },
    });
  }
  return <></>;
};
